// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".2d803b297cc4385bee15b1ae8d933508c5aa0ff2.chunk.js";
};